import { Injectable } from '@angular/core';
import {MatDialog, MatDialogRef, MatDialogConfig} from '@angular/material/dialog';
import { PopupDtoComponent } from 'src/app/sgc/components/pages/popup-dto/popup-dto.component';


@Injectable({
  providedIn: 'root'
})
export class OpenPopupService {

  constructor(public dialog: MatDialog) { }

  id = 0;
  nombre = "";
  descuento = 0;
  curso = "";
  salon = "";
  fechaInicio = "";
  estado = "";
  modalidad = "";
  cupoMinimo = 0;
  cupoMaximo = 0;
  inscritos = 0;
  cargaHoraria = 0;
  horario = "";
  categoria = 0;

  openDialog(idGrupo,nombre,descuento,curso,salon,fechaInicio,estado,modalidad,cupoMinimo,cupoMaximo,inscritos,cargaHoraria,horario) {
    this.id = idGrupo;
    this.nombre = nombre;
    this.descuento = descuento;
    this.curso = curso;
    this.salon = salon;
    this.fechaInicio = fechaInicio;
    this.estado = estado;
    this.modalidad = modalidad;
    this.cupoMinimo = cupoMinimo;
    this.cupoMaximo = cupoMaximo;
    this.inscritos = inscritos;
    this.cargaHoraria = cargaHoraria;
    this.horario = horario;
    this.dialog.open(PopupDtoComponent);
  }
}
